module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: {
      loading: _vm.loading
    },
    attrs: {
      "id": "template-form"
    }
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": "",
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": "",
      "for": "ref"
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.ref")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ref),
      expression: "ref"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ref"
    },
    domProps: {
      "value": (_vm.ref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ref = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.zone.label")))]), _vm._v(" "), _c('Multiselect', {
    staticClass: "uppercase",
    attrs: {
      "options": _vm.zones,
      "multiple": true,
      "show-labels": true,
      "preserve-search": true,
      "placeholder": _vm.$t('template.form.zone.empty'),
      "label": "name",
      "track-by": "name",
      "exact": ""
    },
    model: {
      value: (_vm.selectedZones),
      callback: function($$v) {
        _vm.selectedZones = $$v
      },
      expression: "selectedZones"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.displayerType.label")))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.displayerTypes,
      "label": "name",
      "track-by": "name",
      "searchable": true,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": _vm.$t('template.form.displayerType.empty')
    },
    model: {
      value: (_vm.displayerType),
      callback: function($$v) {
        _vm.displayerType = $$v
      },
      expression: "displayerType"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("template.form.standDesign.label")))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.standDesigns,
      "label": "name",
      "track-by": "name",
      "searchable": true,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": _vm.$t('template.form.standDesign.empty')
    },
    model: {
      value: (_vm.standDesign),
      callback: function($$v) {
        _vm.standDesign = $$v
      },
      expression: "standDesign"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be352c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/template-form.vue
// module id = 3249
// module chunks = 0